import { createRoute } from '@tanstack/react-router';
import { Footer } from 'components/Footer';
import { Header } from 'components/Header';
import { RequestDemoSection } from 'components/sections/RequestDemoSection';
import { RouterKey } from 'consts';
import { useEffect } from 'react';
import { rootRoute } from 'router';

export const RequestDemoPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />
      <main className="pt-20">
        <RequestDemoSection />
      </main>
      <Footer />
    </>
  );
};

export const requestDemoPageRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: RouterKey.REQUEST_DEMO,
  component: RequestDemoPage,
});
